module.exports = __webpack_public_path__ + "assets/static/png/mobsec2_a.a9e89d5fbe4489fbcec77dc61483ca75.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/main/images/mobsec2_a.png
 ** module id = 498
 ** module chunks = 1
 **/